import React from 'react';
import RadioComponent from './RadioComponent';
import Label from './Label';
import Tooltip from './Tooltip';

const PrintConfirmation = (props) => {
  const { name, parameters } = props;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const value = parameters.get ? parameters.get(name) : parameters[name];
  return (
    <div className="form-group">
      <Label label={props.label} required={props.required}>
        <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
      </Label>
      <div className="radio-group">
        <RadioComponent
          {...props}
          checked={value === props.noValue}
          inline
          inputId="print-confirmation-no"
          inputClassName={props.inputClassName}
          label={props.noLabel}
          name={name}
          onChange={onChange}
          value={props.noValue} />
        <RadioComponent
          {...props}
          checked={value === props.yesValue}
          inline
          inputId="print-confirmation-yes"
          inputClassName={props.inputClassName}
          label={props.yesLabel}
          name={name}
          onChange={onChange}
          value={props.yesValue} />
        <div className="error-place" />
      </div>
      {props.children}
    </div>
  );
};

PrintConfirmation.defaultProps = {
  name    : 'print_confirmation',
  label   : 'Send me a Check Plot?',
  yesLabel: 'Yes',
  yesValue: '1',
  noLabel : 'No',
  noValue : '0',
  required: true,
};

export default PrintConfirmation;
